import { useState, useEffect, useCallback } from 'react';

/**
 * Check if code is running in a browser environment
 */
const isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

/**
 * Hook that tracks the document's visibility state
 * @returns The current visibility state ('visible' | 'hidden')
 */
export const useVisibilityState = () => {
  // Default to 'visible' when running on the server
  const [visibilityState, setVisibilityState] = useState<DocumentVisibilityState>(
    isBrowser ? document.visibilityState : 'visible'
  );

  const handleVisibilityChange = useCallback(() => {
    if (isBrowser) {
      setVisibilityState(document.visibilityState);
    }
  }, []);

  useEffect(() => {
    // Only attach listeners in browser environment
    if (!isBrowser) return;
    
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [handleVisibilityChange]);

  return visibilityState;
};
